import { render, staticRenderFns } from "./purchase-unit-price-edit.vue?vue&type=template&id=176d7bda&"
import script from "./purchase-unit-price-edit.vue?vue&type=script&lang=js&"
export * from "./purchase-unit-price-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports